import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import style from './mobile-notification.module.less';

export const MobileNotificationContent = ({ content }) => {
  return (
    <>
      <FontAwesomeIcon className={style.icon} icon={faCheck} />
      <div className={style['mobile-notification-content']}>{content}</div>
    </>
  );
};

MobileNotificationContent.propTypes = {
  content: PropTypes.func.isRequired,
};
